<form id="register-form" [formGroup]="formGroup" (ngSubmit)="updateItem($event)" class="info-content-container">
  <div id="titleHeader" class="title-header flex-row">
    <span class="flex-1">{{ item.title }}</span>
    <button class="icon-button icon-close" (click)="goToHyperlink(item)"></button>
  </div>
  <div class="scroll-container">
    <div class="content">
      <div class="information-container">
        <div class="statistics-title statistics-title--full">
          {{ "users.main.information" | translate }}
        </div>
        <div class="information-content">
          <div class="flex-row">
            <div class="flex-3 card-cell">
              <sag-ui-input formControlName="urlLink" [label]="'hyperlink.item.url' | translate" />
            </div>
            <div class="flex-1 card-cell"></div>
          </div>
          @if (isGermanEnabled) {
            <div class="flex-row">
              <div class="flex-3 card-cell">
                <sag-ui-input formControlName="urlLinkDe" [label]="'hyperlink.item.urlDe' | translate" />
              </div>
              <div class="flex-1 card-cell"></div>
            </div>
          }
          <div class="flex-row">
            <div class="flex-1 card-cell">
              <sag-ui-input formControlName="title" [label]="'hyperlink.item.title' | translate" />
            </div>
            @if (isGermanEnabled) {
              <div class="flex-1 card-cell">
                <sag-ui-input formControlName="titleDe" [label]="'hyperlink.item.titleDe' | translate" />
              </div>
            }
          </div>
          <div class="flex-row">
            <div class="flex-1 card-cell">
              <sag-ui-textarea formControlName="description" [label]="'hyperlink.item.description' | translate" />
            </div>
            @if (isGermanEnabled) {
              <div class="flex-1 card-cell">
                <sag-ui-textarea formControlName="descriptionDe" [label]="'hyperlink.item.descriptionDe' | translate" />
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
